export default "__VITE_ASSET__DbcY_1Ls__"